import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatExpansionModule} from '@angular/material/expansion';
import { CompaniesService } from 'src/app/services/companies.service';

@Component({
  selector: 'app-expanded-vertical-menu',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatExpansionModule],
  templateUrl: './expanded-vertical-menu.component.html',
  styleUrls: ['./expanded-vertical-menu.component.scss']
})
export class ExpandedVerticalMenuComponent {

  private readonly companyService = inject(CompaniesService);

  @Input()
  clientStatus!: number;

  @Input()
  businessStatuses!: number | number[];

  @Input()
  menuSteps!: { name: string, icon: string, subSteps?: {name: string}[] }[];

  @Input()
  formType!: number;

  @Output()
  stepChanged = new EventEmitter<number>();

  @Output() 
  subStepSelected = new EventEmitter<{ stepName: string, subStepName: string }>();

  @Input()
  activeSubStepName: string | null = null;

  @Input()
  selectedIndex: number | null = 0;

  get activeStepName(): string | null {
    return this.menuSteps?.[this.selectedIndex]?.name || null;
  }

  onStepChange(index: number) {

    if (this.isStepDisabled(this.menuSteps[index].name)) {
      return;
    }

    // Simply emit the step change - parent will handle the actual navigation
    this.selectedIndex = index;
    this.stepChanged.emit(index);
  }

  private get companyId(): number {
    return this.companyService.managedCompanyId;
  }

onSubStepClick(stepIndex: number, subStepName: string, event: MouseEvent) {
    event.stopPropagation();

    // UPDATED: Add check to prevent if parent step is disabled
    if (this.isStepDisabled(this.menuSteps[stepIndex].name)) {
      return;
    }

    // Update selection
    this.selectedIndex = stepIndex;
    this.stepChanged.emit(stepIndex);

    const stepName = this.menuSteps[stepIndex].name;
    this.subStepSelected.emit({stepName, subStepName});
  }
  getAllowedSteps(): string[] {
    const allowedSteps = [
      'Individual Information',
      'Government/Tax Information',
      'Officers',
      'Company Information',
      'Governmental Information',
      'Related Companies',
      'Risk Assessment',
      'Identity Details',
      'Documents',
      'DMS'
    ];
  
    const hasPendingReview = Array.isArray(this.businessStatuses) 
      ? this.businessStatuses.includes(11) 
      : this.businessStatuses === 11;
  
    if (this.clientStatus !== 0 && hasPendingReview) {
      allowedSteps.push('Services & Fees');
    }
  
    if (this.companyId === 9 || this.companyId === 26) {
      allowedSteps.push('Klidi');
    }
    return allowedSteps;
  }
  
  isStepDisabled(stepName: string): boolean {
    const allowedSteps = this.getAllowedSteps();
    return (this.clientStatus === 1 || this.clientStatus === 2) && !allowedSteps.includes(stepName);
  }
}